import { smartDueLabel, smartDueUrgency } from "@/lib/constants";
import { Clock } from "lucide-react";

const URGENCY_STYLES = {
  overdue: "text-red-600",
  today: "text-amber-600",
  future: "text-navy/60",
  muted: "text-muted-foreground",
};

export default function SmartDueLabel({ dueAt, className = "" }) {
  const label = smartDueLabel(dueAt);
  const urgency = smartDueUrgency(dueAt);
  const style = URGENCY_STYLES[urgency] || URGENCY_STYLES.muted;

  return (
    <span className={`inline-flex items-center gap-1 text-xs font-medium ${style} ${className}`}>
      <Clock className="h-3 w-3" />
      {label}
    </span>
  );
}
